import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore,
  User,
} from 'oidc-client';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const adVersion =
  process.env.REACT_APP_AAD_VERSION ||
  (() => {
    throw new Error('REACT_APP_AAD_VERSION environmental variable not set');
  })();

const isVersion2 = adVersion === '2';

const adTenant =
  process.env.REACT_APP_AAD_TENANT ||
  (() => {
    throw new Error('REACT_APP_AAD_TENANT environmental variable not set');
  })();

const signInPolicy_v1 =
  process.env.REACT_APP_AAD_SIGNINPOLICY_1 ||
  (() => {
    throw new Error(
      'REACT_APP_AAD_SIGNINPOLICY_1 environmental variable not set'
    );
  })();

const signInPolicy_v2 =
  process.env.REACT_APP_AAD_SIGNINPOLICY_2 ||
  (() => {
    throw new Error(
      'REACT_APP_AAD_SIGNINPOLICY_2 environmental variable not set'
    );
  })();

const signInPolicy = isVersion2 ? signInPolicy_v2 : signInPolicy_v1;

const adClientId =
  process.env.REACT_APP_AAD_CLIENTID ||
  (() => {
    throw new Error('REACT_APP_AAD_CLIENTID environmental variable not set');
  })();

const reactAppScope =
  process.env.REACT_APP_AAD_SCOPES ||
  (() => {
    throw new Error('REACT_APP_AAD_SCOPES environmental variable not set');
  })();

const redirect =
  process.env.REACT_APP_BASE_URL ||
  (() => {
    throw new Error('REACT_APP_BASE_URL environmental variable not set');
  })();

const postLogoutRedirect =
  process.env.REACT_APP_AAD_LOGOUT_URL ||
  (() => {
    throw new Error('REACT_APP_AAD_LOGOUT_URL environmental variable not set');
  })();

const baseUrl =
  process.env.REACT_APP_BASE_URL ||
  (() => {
    throw new Error('REACT_APP_BASE_URL environmental variable not set');
  })();

const authority_v1 = `https://login.microsoftonline.com/tfp/${adTenant}.onmicrosoft.com/${signInPolicy}/v2.0`;
const authority_v2 = `https://${adTenant}.b2clogin.com/${adTenant}.onmicrosoft.com/${signInPolicy_v2}/v2.0`;
const authority = isVersion2 ? authority_v2 : authority_v1;

const scope = `https://${adTenant}.onmicrosoft.com/${reactAppScope} openid profile`;

const userManagerSettings: UserManagerSettings = {
  authority: authority,
  client_id: adClientId,
  scope: scope,
  redirect_uri: redirect + `callback`,
  //silent_redirect_uri: `${baseUrl}signinSilentCallback`,
  silent_redirect_uri: `${baseUrl}silent-callback.html`,
  post_logout_redirect_uri: encodeURI(postLogoutRedirect + baseUrl),
  accessTokenExpiringNotificationTime: 60, // Default is 60 (1 minute) //3540
  //accessTokenExpiringNotificationTime: 3540,
  /**
   * Optional settings if you want silent renew
   */
  automaticSilentRenew: true, // Set to true if you have included silent-renew.html to /public
  includeIdTokenInSilentRenew: true, // Set to true if you have included silent-renew.html to /public
  silentRequestTimeout: 30000, // Default is 10000 (10 seconds), but is set to 30 seconds to handle slow loading
  /**
   * You should not modify these settings
   */
  userStore: new WebStorageStateStore({
    // Do not change this (sessionStorage is the default, but specified for clarity)
    store: window.sessionStorage, // sessionStorage does so that state does not conflict across tabs at the price of an extra roundtrip
  }),
  response_type: 'id_token token', // Do not change this (PKCE is not supported by AADB2C)
  loadUserInfo: false, // Do not change this (userinfo endpoint not supported by AADB2C)
};

const userManager = new UserManager(userManagerSettings);

userManager.events.addUserLoaded((u: User) => {
  Logger.info(['USERMANAGER::addUserLoaded', u], LogArea.Security);
});

userManager.events.addAccessTokenExpiring(() => {
  Logger.info(['USERMANAGER::TokenExpiring'], LogArea.Security);
});

userManager.events.addSilentRenewError(() => {
  const state = window.location.pathname + window.location.search;
  Logger.info(['USERMANAGER::SilentError', state], LogArea.Security);
  userManager.signinRedirect({ state });
});

export { userManager };
